export const UNIT_OPTIONS = {
    METRIC: "Metric",
    IMPERIAL: "US"
};

export const LANGUAGE_OPTIONS = {
    ENGLISH: "English",
    SPANISH: "Spanish",
    FRENCH: "French"
};

export const LANGUAGE_LOCALE_MAP = {
    [LANGUAGE_OPTIONS.ENGLISH]: "en",
    [LANGUAGE_OPTIONS.SPANISH]: "es",
    [LANGUAGE_OPTIONS.FRENCH]: "fr"
};

export const UNIT_OPTIONS_LIST = Object.values(UNIT_OPTIONS);
export const LANGUAGE_OPTIONS_LIST = Object.values(LANGUAGE_OPTIONS);